import router from './router'
import useMessagesStore from './store'
import MessagesMessages from './localization'

export default {
  router,
  useMessagesStore,
  localization: MessagesMessages,
}
